export default "__VITE_ASSET__DhZg$RTQ__"